export default () => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {width: 40, align: 'center', fixed: 'left', type: 'checkbox'},
  {
    field: 'col-opt',
    title: '操作',
    headerAlign: 'center',
    align: 'left',
    fixed: 'left',
    width: 200,
    slots: {
      default: 'opt',
    },
  },
  {
    field: 'dispatchOrderNo',
    title: '调度订单编号',
    headerAlign: 'center',
    align: 'center',
    fixed: 'left',
    width: 170,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'orderNo',
    title: '原订单编号',
    align: 'center',
    fixed: 'left',
    width: 150,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    slots: {
      default: 'orderNo',
    },
  },
  {
    field: 'bizBillNo',
    title: 'ERP/WMS单号',
    headerAlign: 'center',
    align: 'center',
    fixed: 'left',
    width: 150,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'orderSoNo',
    title: '销售订单号',
    headerAlign: 'center',
    align: 'center',
    fixed: 'left',
    width: 120,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    slots: {default: 'orderso'}
  },
  {
    field: 'totQty',
    title: '剩余件数',
    headerAlign: 'center',
    align: 'left',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'totInWeight',
    title: '剩余重量',
    headerAlign: 'center',
    align: 'left',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'totInVolume',
    title: '剩余体积',
    headerAlign: 'center',
    align: 'left',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'showOrderDate',
    title: '客户托运日期',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'orderCreateTime',
    title: '制单时间',
    headerAlign: 'center',
    align: 'center',
    width: 160,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'orderCreateByName',
    title: '制单人',
    headerAlign: 'center',
    align: 'left',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },

  {
    field: 'custShortName',
    title: '客户',
    headerAlign: 'center',
    align: 'left',
    width: 140,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
  {
    field: 'orderTypeName',
    title: '订单类型',
    headerAlign: 'center',
    align: 'center',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'bizTypeName',
    title: '业务类型',
    headerAlign: 'center',
    align: 'center',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'transportModeName',
    title: '运输模式',
    headerAlign: 'center',
    align: 'center',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'wayBillNo',
    title: '运单号',
    headerAlign: 'center',
    align: 'center',
    width: 150,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'vehicleModelName',
    title: '车型',
    headerAlign: 'center',
    align: 'center',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'vehicleLengthName',
    title: '车长',
    headerAlign: 'center',
    align: 'center',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'vehicleLoad',
    title: '载重',
    headerAlign: 'center',
    align: 'center',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'vehicleVolume',
    title: '载方',
    headerAlign: 'center',
    align: 'center',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'orgName',
    title: '组织机构',
    headerAlign: 'center',
    align: 'left',
    width: 180,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'uploadReceiptFlagName',
    title: '是否上传回单',
    headerAlign: 'center',
    align: 'left',
    width: 180,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'isTransferDispatchName',
    title: '是否为中转运单',
    headerAlign: 'center',
    align: 'left',
    width: 180,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'transferTypeName',
    title: '中转类型',
    headerAlign: 'center',
    align: 'left',
    width: 180,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'pickupPointName',
    title: '发货方',
    headerAlign: 'center',
    align: 'left',
    width: 120,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
  {
    field: 'pickupProvinceName',
    title: '发货省份',
    headerAlign: 'center',
    align: 'left',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'pickupCityName',
    title: '发货城市',
    headerAlign: 'center',
    align: 'left',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
  {
    field: 'pickupDistrictName',
    title: '发货区县',
    headerAlign: 'center',
    align: 'left',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'pickupAddress',
    title: '发货地址',
    headerAlign: 'center',
    align: 'left',
    width: 180,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'pickupContactName',
    title: '发货联系人',
    headerAlign: 'center',
    align: 'left',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'pickupContactMobile',
    title: '发货手机号',
    headerAlign: 'center',
    align: 'center',
    width: 110,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'pickupContactPhone',
    title: '发货联系电话',
    headerAlign: 'center',
    align: 'center',
    width: 110,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'pickupContactEmail',
    title: '发货联系邮件',
    headerAlign: 'center',
    align: 'left',
    width: 120,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'pickupRemark',
    title: '发货备注',
    headerAlign: 'center',
    align: 'left',
    width: 150,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'receivePointName',
    title: '收货方',
    headerAlign: 'center',
    align: 'left',
    width: 120,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
  {
    field: 'receiveProvinceName',
    title: '收货省份',
    headerAlign: 'center',
    align: 'left',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
  {
    field: 'receiveCityName',
    title: '收货城市',
    headerAlign: 'center',
    align: 'left',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
  {
    field: 'receiveDistrictName',
    title: '收货区县',
    headerAlign: 'center',
    align: 'left',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string',
  },
  {
    field: 'receiveAddress',
    title: '收货地址',
    headerAlign: 'center',
    align: 'left',
    width: 150,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'receiveContactName',
    title: '收货联系人',
    headerAlign: 'center',
    align: 'left',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'receiveContactMobile',
    title: '收货手机号',
    headerAlign: 'center',
    align: 'center',
    width: 110,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'receiveContactPhone',
    title: '收货电话',
    headerAlign: 'center',
    align: 'center',
    width: 110,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'receiveContactEmail',
    title: '收货邮件',
    headerAlign: 'center',
    align: 'left',
    width: 120,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'receiveRemark',
    title: '收货备注',
    headerAlign: 'center',
    align: 'left',
    width: 150,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  // {
  //   field: 'totQty',
  //   title: '总件数',
  //   width: 80,
  //   showHeaderOverflow: 'title',
  //   showOverflow: 'ellipsis',
  // },
  // {
  //   field: 'totInWeight',
  //   title: '总收入重量kg',
  //   width: 100,
  //   showHeaderOverflow: 'title',
  //   showOverflow: 'ellipsis',
  // },
  // {
  //   field: 'totInVolume',
  //   title: '总收入体积m³',
  //   width: 100,
  //   showHeaderOverflow: 'title',
  //   showOverflow: 'ellipsis',
  // },
  {
    field: 'totPayWeight',
    title: '总支出重量kg',
    align: 'center',
    width: 110,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'totPayVolume',
    title: '总支出体积m³',
    align: 'center',
    width: 110,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'totValue',
    title: '总货值',
    align: 'center',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'pickDatetimeBegin',
    title: '提货时间开始',
    align: 'center',
    width: 160,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'pickDatetimeEnd',
    title: '提货时间截止',
    align: 'center',
    width: 160,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'receiveDatetimeBegin',
    title: '收货时间开始',
    align: 'center',
    width: 160,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'receiveDatetimeEnd',
    title: '收货时间截止',
    align: 'center',
    width: 160,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'transportHours',
    title: '运输时效',
    align: 'center',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  // {
  //   field: 'orderBizStatusName',
  //   title: '业务状态',
  //   width: 80,
  //   showHeaderOverflow: 'title',
  //   showOverflow: 'ellipsis',
  // },
  {
    field: 'createTime',
    title: '提交时间',
    align: 'center',
    width: 160,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'createByName',
    title: '提交人',
    headerAlign: 'center',
    align: 'left',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
]
